// @ts-nocheck
import { Box, Grid, Typography } from "@mui/material";
import styles from "./../contractDetails.module.css";
import { CustomIconButton } from "../../../components/Custom/CustomIconButton";
import { getCssVariableHandler } from "../../../utils/styles/getCssVariables";
import PropTypes from "prop-types";
import { useNavigate } from "react-router-dom";
import { useEffect, useMemo, useState } from "react";
import { apiRequest } from "../../../services/apiService";
import _, { debounce } from "lodash";
import { useDispatch, useSelector } from "react-redux";
import { Close } from "@mui/icons-material";
import { getUniversalDateTimeFormat } from "../../../utils/methods/universalDateTimeFormat";
import { isUserRole } from "../../../utils/methods/storeFunc";
import { USER_ROLES } from "../../../staticData/userRoles";
import WhiteFile from "./../../../assets/svgs/white-file.svg";
import {
  getStatusColor,
  getStatusText,
  getTitleForContractStatus,
} from "../../../utils/methods/contract/contractMethods";
import theme from "../../../theme";
import { FileUploadSmall } from "./FileUpload";
import { uploadRequiredDocumentAction } from "../../../store/actions/contractor";
import { alertDialogAciton } from "../../../store/actions/auth";

export const ViewDetailsForm = ({
  existingData,
  values,
  setFieldValue,
  readOnly,
  status,
  file,
}) => {
  const { userRole } = useSelector((state) => state?.auth);
  const [loaderId, setLoaderId] = useState(null);
  const dispatch = useDispatch();

  const timeStatus = useMemo(() => {
    return getTitleForContractStatus({
      status: existingData?.status,
      contractData: existingData,
      userRole,
    });
  }, [existingData, userRole]);

  const requiredDocumentsUploadHandler = ({ event, _id }) => {
    setLoaderId(_id);
    const file = event?.target?.files?.[0];
    const formData = new FormData();
    formData.append("files", file);
    dispatch(
      uploadRequiredDocumentAction({
        payload: {
          data: formData,
          params: {
            id: _id,
          },
        },
        successCallback: (rD) => {
          setFieldValue("requiredDocuments", rD);
          setLoaderId(null);
        },
        failureCallback: (msg) => {
          setLoaderId(null);
          dispatch(
            alertDialogAciton({
              open: true,
              title: "Error",
              message: msg || "Failed to add document",
            }),
          );
        },
      }),
    );
  };

  let statusColor = getStatusColor(existingData?.status);

  return (
    <>
      <Box className={styles["view-details-container"]}>
        {/* name and stats */}
        <Box className={styles["edge-to-edge"]}>
          <Typography className={styles["view-title"]}>
            {existingData?.contractName}
          </Typography>
          <Typography className={styles["key-val-container"]}>
            <Typography className={styles["key"]}>Status :</Typography>
            <Typography
              sx={{
                color: statusColor,
                border: "1px solid",
                borderColor: statusColor,
                borderRadius: "0.5rem",
                padding: "0.25rem 0.5rem",
              }}
            >
              {getStatusText(existingData?.status)}
            </Typography>
          </Typography>
        </Box>

        {/* description */}
        <Box>
          <Typography className={styles["key-title"]}>Description</Typography>
          <Typography
            className={`${styles["key-details"]} ${styles["opacity-75"]}`}
          >
            {existingData?.description}
          </Typography>
        </Box>

        {/* client name in case it's for admin/superadmin */}
        {isUserRole(USER_ROLES.SUPERADMIN, USER_ROLES.ADMIN) && (
          <Box>
            <Typography className={styles["key-title"]}>
              Contract For
            </Typography>
            <Typography
              className={`${styles["key-details"]} ${styles["opacity-75"]}`}
            >
              {existingData?.recipients?.name}
              <Typography
                sx={{
                  display: "inline-flex",
                  marginLeft: "0.25rem",
                  color: theme.palette.green.main,
                }}
              >
                ({existingData?.recipients?.userRole})
              </Typography>
            </Typography>
          </Box>
        )}

        {/* event name and received on */}
        <Box className={styles["edge-to-edge"]}>
          {existingData?.eventName && (
            <Typography className={styles["key-val-container"]}>
              <Typography
                className={styles["key-title"]}
                sx={{
                  color: getCssVariableHandler({
                    variableName: "--primary-pink-hex",
                  }),
                }}
              >
                Event Name :
              </Typography>
              <Typography
                className={`${styles["key-details"]} ${styles["opacity-75"]}`}
              >
                {existingData?.eventName}
              </Typography>
            </Typography>
          )}
        </Box>
        <Box className={styles["edge-to-edge"]}>
          {existingData?.eventName && (
            <Typography className={styles["key-val-container"]}>
              <Typography
                className={styles["key-title"]}
                sx={{
                  color: getCssVariableHandler({
                    variableName: "--primary-pink-hex",
                  }),
                }}
              >
                Event Duration:{" "}
                <Typography component={"span"} color={"white"}>
                  Start Date:
                </Typography>
              </Typography>
              <Typography
                className={`${styles["key-details"]} ${styles["opacity-75"]}`}
              >
                {getUniversalDateTimeFormat({
                  dateTime: existingData?.eventStart,
                })}
              </Typography>
            </Typography>
          )}
          {existingData?.eventName && (
            <Typography className={styles["key-val-container"]}>
              <Typography
                className={styles["key-title"]}
                sx={{
                  color: getCssVariableHandler({
                    variableName: "--white-rgb",
                  }),
                }}
              >
                End Date:
              </Typography>
              <Typography
                className={`${styles["key-details"]} ${styles["opacity-75"]}`}
              >
                {getUniversalDateTimeFormat({
                  dateTime: existingData?.eventEnd,
                })}
              </Typography>
            </Typography>
          )}
        </Box>

        <Box className={styles["edge-to-edge"]}>
          {existingData?.sentOn && (
            <Typography className={styles["key-val-container"]}>
              <Typography
                className={styles["key-title"]}
                sx={{
                  color: getCssVariableHandler({
                    variableName: "--primary-green-text-hex",
                  }),
                }}
              >
                {isUserRole(USER_ROLES.SUPERADMIN, USER_ROLES.ADMIN)
                  ? "Send On"
                  : "Received On"}{" "}
                :
              </Typography>
              <Typography
                className={`${styles["key-details"]} ${styles["opacity-75"]}`}
              >
                {getUniversalDateTimeFormat({
                  dateTime: existingData?.sentOn,
                })}
              </Typography>
            </Typography>
          )}
          {existingData?.verifiedOn && (
            <Typography className={styles["key-val-container"]}>
              <Typography
                className={styles["key-title"]}
                sx={{
                  color: getCssVariableHandler({
                    variableName: "--primary-green-text-hex",
                  }),
                }}
              >
                Verified On :
              </Typography>
              <Typography
                className={`${styles["key-details"]} ${styles["opacity-75"]}`}
              >
                {getUniversalDateTimeFormat({
                  dateTime: existingData?.verifiedOn,
                })}
              </Typography>
            </Typography>
          )}
        </Box>

        {/* required docuemnts list */}
        <Box sx={{ width: "100%" }}>
          <Typography className={styles["key-title"]}>
            Required Documents
          </Typography>
          <Box className={styles["required-documents-container"]}>
            {values?.requiredDocuments?.length == 0 && (
              <Typography
                className={`${styles["key-details"]} ${styles["opacity-75"]}`}
                sx={{ textWrap: "nowrap" }}
              >
                No Required Documents
              </Typography>
            )}
            <Grid container spacing={1}>
              {values?.requiredDocuments?.map((item) => {
                return (
                  <Grid item xs={12} md={6} lg={4} key={item?._id}>
                    <Box className={styles["document"]}>
                      <Typography className={styles["opacity-75"]}>
                        {item?.name}
                      </Typography>
                      {/* upload and file name use formik to handle this */}
                      {item?.url ? (
                        <Box className={styles["file-btn-container"]}>
                          <img alt={"File image"} src={WhiteFile} />
                          <Typography
                            className={`${styles["label"]} ${styles["color-pink"]}`}
                            sx={{
                              fontSize: "0.8rem",
                              cursor: "pointer",
                              userSelect: "none",
                              "&:active": {
                                opacity: "0.8",
                              },
                            }}
                            onClick={() => {
                              const anchor = document.createElement("a");
                              anchor.href = item.url;
                              anchor.download = item.name;
                              anchor.target = "_blank";
                              anchor.click();
                            }}
                          >
                            {item?.name}
                          </Typography>
                          {!status && (
                            <CustomIconButton
                              sx={{
                                backgroundColor: "white",
                                padding: 0,
                                "&:hover": {
                                  backgroundColor: "white",
                                  opacity: "0.8",
                                },
                              }}
                              onClick={() => {}}
                            >
                              <Close
                                sx={{ fontSize: "1rem", color: "black" }}
                              />
                            </CustomIconButton>
                          )}
                        </Box>
                      ) : (
                        <FileUploadSmall
                          isLoading={loaderId === item?._id}
                          fileChangeHandler={(e) =>
                            requiredDocumentsUploadHandler({
                              event: e,
                              _id: item?._id,
                            })
                          }
                        />
                      )}
                    </Box>
                  </Grid>
                );
              })}
            </Grid>
          </Box>
        </Box>
      </Box>
    </>
  );
};

ViewDetailsForm.propTypes = {
  setCurrentStep: PropTypes.func,
  setConData: PropTypes.func,
  existingData: PropTypes.object || null,
  readOnly: PropTypes.bool,
  status: PropTypes.string,
  values: PropTypes.object,
  setFieldValue: PropTypes.func,
  submitForm: PropTypes.func,
  setValues: PropTypes.func,
  errors: PropTypes.object,
  handleChange: PropTypes.func,
  handleBlur: PropTypes.func,
  touched: PropTypes.func,
  handleContractUpload: PropTypes.func,
  clearFile: PropTypes.func,
  file: PropTypes.any,
  showErrors: PropTypes.bool,
};